module.exports = __webpack_public_path__ + "img/gallery-21.72d654e6.jpg";